/** @format */
import React from 'react';
import styled from 'styled-components';

import { MasonryGridEntry } from '@toucan/common/contentful/types';

import { MasonryGridImage } from './masonry-grid-image';
import { styles } from './masonry-grid.style';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type MasonryGridProps = MasonryGridEntry;

const StyledContentfulMasonryGrid = styled.div`
    ${styles}
`;

export const ContentfulMasonryGrid = ({
    topLeftImage,
    topLeftCaption,
    rightImage,
    rightCaption,
    bottomLeftImage,
    bottomLeftCaption,
}: MasonryGridProps) => {
    return (
        <StyledContentfulMasonryGrid className="masonry-grid">
            <MasonryGridImage image={topLeftImage} caption={topLeftCaption} />
            <MasonryGridImage image={rightImage} caption={rightCaption} />
            <MasonryGridImage
                image={bottomLeftImage}
                caption={bottomLeftCaption}
            />
        </StyledContentfulMasonryGrid>
    );
};
